import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination, Scrollbar, A11y } from "swiper";
import helpers from "../Constants/helpers";
import { Link } from "react-router-dom";

function SubCats(props) {
  const { subCats } = props;

  return (
    subCats.length > 0 && (
      <div className={`container mt-3`}>
        <h4>{window.t("subCats")}</h4>
        <Swiper
          slidesPerView={2}
          modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y]}
          pagination={false}
          spaceBetween={20}
          navigation={true}
          autoplay={{
            delay: 2600,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
        >
          {subCats &&
            subCats.map((cat) => (
              <SwiperSlide key={cat.id}>
                <div className="card product-card-alt">
                  <div className="product-thumb">
                    <div className="product-card-actions"></div>
                    <a className="product-thumb-overlay"> </a>
                    <img
                      src={helpers.getImageUrl(cat.attachment)}
                      alt={cat.name}
                      style={{ height: 180 }}
                    />
                  </div>
                  <div className="card-body">
                    <h3 className="product-title fs-sm mb-2 text-center">
                      <Link to={`/shop?category=${cat.id}&level=false`}>
                        {cat.name}
                      </Link>
                    </h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    )
  );
}

export default SubCats;
